import * as React from 'react';

import { useRouter } from 'next/router';

/**
 * It is needed for loading shared page with hash
 */
const PAGE_RENDER_DELAY = 100;

function useScrollToHash(): void {
  const router = useRouter();

  const scrollToHash = (hash: string): void => {
    const element = document.getElementById(hash);
    if (element) {
      element.scrollIntoView({ behavior: 'auto' });
    }
  };

  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      // Handle initial page load
      if (window.location.hash) {
        const hash = window.location.hash.substring(1);
        setTimeout(() => scrollToHash(hash), PAGE_RENDER_DELAY);
      }

      // Handle route changes
      const handleRouteChange = (url: string): void => {
        const hash = url.split('#')[1];
        if (hash) {
          setTimeout(() => scrollToHash(hash), 0);
        }
      };

      router.events.on('routeChangeComplete', handleRouteChange);

      return () => {
        router.events.off('routeChangeComplete', handleRouteChange);
      };
    }
    return;
  }, [router]);
}

export { useScrollToHash };
